module.exports = __webpack_public_path__ + "fonts/Timelapse.089bbe4b.ttf";